import { User } from "../../shared/models/user.model";

export class MasterRequest {
	MasterUnitId: number;
	UnitName: string;
	MasterCompanyId: number = 0;
	MasterLocationId: number;
	MasterRequestId: number;
	PassTypeId: number;
	PreRequisiteConfigurationId: number;
	RaisedBy: number;
	Requests: Request[] = [];
	CompanyName: string;
	LocationName: string;
	PassTypeName: string;
	PassRequestId: number = 0;
	IsOffice: boolean;
	InActive: boolean = false;
	Checked: boolean;
	CheckInOutDetails: any;
	UnitId: number;
	CompanyId: number;
	LocationId: number;
	IsDraft:boolean=false;
	UserId:number = 0;//Pritesh
	Contract:number = 0;
	ContractHolder:string;
	ContractNumber:string;
}

export class Request {
	ApprovingAuthorityId: number = 0; // Contractor/HR
	ContractorOrHseStatus: string = 'Pending for Approval';
	Id: string;
	ExpiryDate: Date = new Date();
	ValidityDate: Date = new Date();
	PassRequestFromDate: Date = new Date();
	PassRequestToDate: Date = new Date();
	PassRequestStatus: string = '';
	CompanyName: string;
	JobDescription: string;
	FullName: string;
	DepartmentName: string;
	Designation: string;
	DesignationText: string;
	CreatedBy: number;
	PassTypeName: string;
	PrerequisiteDocuments: Document[] = [];
	Blocked: boolean = false;
	EmailId: string;
	PassRequestId: number;
	PassRequestLogInfo: PassRequestLog;
	PassRequestStatusId: number;
	QRCode: string;
	Location: string;
	FullNameUser: User;
	PrintPass: string;
	BlockedRemarks: string;
	DocumentStatus: string;
	PassId: string;
	PassStatusName: string;
	UnitId: number;
	LocationId: number;
	CompanyId: number;
	PreRequisiteConfigurationId: number;
	PassTypeId: number;
	RaisedBy: number;
  ApprovalStatus:string;
  UserId:number = 0;//Pritesh
  ContractId:number=0;
}

export class Document {
	DocumentId: number = 0;
	PassRequestId: number;
	PreRequisiteDetailsId: number;
	DocumentDocListId: number = 0;
	Name: string = '';
	HSECheckDocuments: any[] = [];  // Document File
	Documents: any[] = [];
	ExpiryDate: Date = new Date();
	POBHSEDocumentStatusName: string = '';
	POBHSEDocumentStatusId: number = 0;
	HseRemarks: string = '';
	IsExpiryNeeded: boolean = false;
	Version: number;
	Value: string;
	PrerequisiteConfigurationMappingId: number;
	TypeOfData: string;
	IsDocumnentErrorMsg: boolean;
	PrerequisiteName: string;
}
export class PassRequestLog {
	Action: string;
	ActedByUserName: string;
	ActedBy: number;
	ActedOn: Date;
}

export class Pass {
	PassName: string;
	PassId: number
}
export class PrerequisteConfiguration {
	UnitId: number;
	CompanyId: number;
	LocationId: number;
	PassTypeId: number;
	PreRequisiteConfigurationId: number;
}

export class PassRequestStatusData {
	PassRequestStatusId: number;
	Name: string;
	checked: boolean = false;
	value: string;
}

export class PassRequestDashBoardFilter {
	PassRequestStatusId: any[] = [];
	IsHseCheck: boolean;
	IsContractHolder: boolean;
	IsMypassRequest: boolean;
	IsHasItBeenMadeCompliant: boolean[] = [];
	IsPassRequestReport: boolean;
	PageSize: number;
	PageIndex: number;
	CurrentPage: number;
	SearchText: string;
	OrderdByColoumName: string;
	OrderdBy: string;
	UserId: number = 0;
	Locations: number[] = [];
	Companies: number[] = [];
	PassRequestFromDate: Date;
	PassRequestToDate: Date;
	UnitId: number;
	Units: number[] = [];
	SelectAll: boolean;
	SourceIds: number[] = [];
  PassType: number[];
}

export class ApprovingAuthorityUser {
	CurrentSelectedPassTypeName: string;
	CurrentSelectedUnitId: number;
}

export class ContractHolderStatus {
	RaisedBy: number;
	PassRequestId: number = 0;
	ContractorOrHseStatus: string;
	ContractorOrHseRemarks: string;
}
export class CheckInCheckOutUser {
	UserId: number;
	PassId: string;
	CheckInTime: Date = new Date();
	CheckOutTime: Date = new Date();
	InOrOut: string;
	CheckInLocation: string;
	CheckOutLocation: string;
	InLocation: number;
	OutLocation: number;
}
export class CompanyDetails {
	CompanyId: number;
	CompanyName: string;
	checked: boolean = false;
}
export class Location {
	LocationId: number;
	LocationName: string;
	checked: boolean = false;
}
export class CheckInCheckOutDetails {
	CheckInTime: Date;
	CheckOutTime: Date;
	ExpiryDate: Date;
	PassRequestFromDate: Date;
	CheckInLocation: string;
	CheckOutLocation: string;
}

export class PassRequestReportDetails {
	TotalNumberOfDelayedRequest: number;
	TotalNumberOfWaivedRequest: number;
	DelayedRequestConvertedIntoCompliance: number;
	PendingCompliance: number;
	NonConformancesCount: number;
}
